import { PropsWithChildren } from "react";
import { PcHeader } from "../pc-header/pc-header";
import { isMobile } from "react-device-detect";
import BottomBar from "@/components/bottomBar";
import PcTopBar from "../pc-topbar";
import TopBar from "@/components/topBar";
import "./reset-antd.css";

export function AcendexLayout(
  props: PropsWithChildren<{
    bottomBarIndex?: number;
    theme?: "light" | "dark";
    hideBottomBar?: boolean;
    pcTopBarTitle?: string;
    mobileTopBarTitle?: string;
    topBarRightContent?: React.ReactNode;
  }>
) {
  return (
    <>
      {!isMobile && <PcHeader theme={props.theme} />}
      {!isMobile && props.pcTopBarTitle && (
        <PcTopBar title={props.pcTopBarTitle} theme={props.theme} rightContent={props.topBarRightContent} />
      )}
      {isMobile && props.mobileTopBarTitle && (
        <TopBar
          title={props.mobileTopBarTitle}
          isBack={true}
          theme={props.theme}
          rightContent={props.topBarRightContent}
        />
      )}
      {props.children}
      {!props.hideBottomBar && isMobile && (
        <BottomBar index={props.bottomBarIndex} />
      )}
    </>
  );
}
